import { combineReducers } from 'redux';
import { IntlReducer as Intl } from 'react-redux-multilingual';

import appReducer from './reducers/appReducer';
import reservationReducer from './reducers/reservationReducer';

export default combineReducers({
  Intl,
  app: appReducer,
  reservation: reservationReducer
});
